/*@ngInject*/
export default ['$resource','BASE_URL', function ($resource, BASE_URL){ return $resource(BASE_URL + "/settings/notifications/:action", {}, {
    get: {method: 'GET', isArray: false},
    save: {method: 'POST'},
    recharge: {method: 'GET', params: {action: 'recharge'}, isArray: false},
    resetRechargeFailed: {method: 'POST', params: {action: 'recharge'}}
})}];
